import React from "react";
import { Check } from "lucide-react";
import { Reveal, Eyebrow, StaggerGroup, StaggerItem } from "./Reveal";
import { COURSE } from "../../data/course";

export default function Included() {
  const { included } = COURSE;
  return (
    <section id="included" data-testid="included-section" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="rounded-[2rem] border border-[#293891]/10 bg-gradient-to-br from-white to-[#EEF2FB] p-8 shadow-[0_30px_80px_-50px_rgba(41,56,145,0.35)] md:p-14">
          <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
            <div>
              <Reveal>
                <Eyebrow>Everything Included</Eyebrow>
              </Reveal>
              <Reveal delay={0.1}>
                <h2 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tight text-[#293891] sm:text-5xl">
                  Everything in your learning journey.
                </h2>
              </Reveal>
              <Reveal delay={0.2}>
                <p className="mt-6 max-w-sm text-base leading-relaxed text-[#566076]">{included.intro}</p>
              </Reveal>
              <Reveal delay={0.3}>
                <div className="mt-8 inline-flex items-center gap-3 rounded-2xl border border-[#293891]/10 bg-white px-5 py-4">
                  <span className="font-display text-3xl font-semibold text-[#e63329]">1</span>
                  <span className="text-sm leading-tight text-[#3A4152]">
                    program.
                    <br />
                    everything you need.
                  </span>
                </div>
              </Reveal>
            </div>

            <StaggerGroup className="grid gap-x-8 gap-y-4 sm:grid-cols-2">
              {included.items.map((item) => (
                <StaggerItem key={item} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#3B82F6] text-white">
                    <Check size={13} />
                  </span>
                  <span className="text-sm text-[#3A4152] md:text-base">{item}</span>
                </StaggerItem>
              ))}
            </StaggerGroup>
          </div>
        </div>
      </div>
    </section>
  );
}
